import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("view", {
    class: "container ion-justify-content-center ion-padding-top ion-padding-bottom",
    style: _normalizeStyle(_ctx.inlineStyle)
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("span", {
      class: "firecracker-spinner",
      role: "status",
      "aria-label": "Loading"
    }, [
      _createElementVNode("svg", {
        class: "firecracker-spinner__art",
        viewBox: "0 0 48 48",
        "aria-hidden": "true",
        focusable: "false"
      }, [
        _createElementVNode("circle", {
          class: "firecracker-spinner__track",
          cx: "24",
          cy: "24",
          r: "21"
        }),
        _createElementVNode("circle", {
          class: "firecracker-spinner__arc",
          cx: "24",
          cy: "24",
          r: "21"
        })
      ])
    ], -1)
  ]))], 4))
}